import Router from 'next/router';
import qs from 'query-string';

import { PATH } from '../../config';
import repo from '../../service/repository';
import storage from '../../service/storage';
import { checkCreditCardBinding, login } from '../common-methods';

const Methods = (get) => {
  return {
    login,
    splash: async () => {
      const { error, data } = await repo.fetchBootstraps();
      if (error) return get().showFailMessage(error);
      get().updateBootstrap(data);

      const searchQuery = qs.parse(location.search);

      if (searchQuery.OneTimeToken || searchQuery.oneTimeToken) {
        await repo.fetchOneTimeToken(
          searchQuery.OneTimeToken || searchQuery.oneTimeToken,
        );
      }

      // If the user enter PBA/maps from RICAHRT_LIFE, and the user is not logged in, let the user stay in the page (DO NOT REDIRECT TO EXPIRED PAGE)
      if (Router.asPath.includes(PATH.MAPS)) {
        return { path: Router.asPath };
      }

      if (storage.getAuth()?.accessToken) {
        return login(
          async (payload) => {
            get().updateApp(payload);
            // connectMQTT(get(), { client: payload.me.id, password: storage.getAuth().accessToken });

            // 確認是否是從 mochipay gateway 的 fallback
            const { path, paymentBindingFail } =
              await checkCreditCardBinding(get);

            if (path) {
              return { path, paymentBindingFail };
            }
            const pathname = Router.asPath.split('?')[0];

            // 4040
            const isPathFullyMatch = (p) => {
              const searchParamsIndex = pathname.indexOf('?');
              if (searchParamsIndex > 0) {
                return pathname.slice(0, searchParamsIndex) === p;
              } else {
                return pathname === p;
              }
            };

            if (!Object.values(PATH).some(isPathFullyMatch)) {
              return { path: PATH.MAIN };
            }

            const skippedPath = ['/', PATH.USER_WELCOME, PATH.USER_LOGIN];

            return {
              path:
                skippedPath.indexOf(pathname) !== -1
                  ? PATH.MAIN
                  : `${Router.asPath}`,
            };
          },
          (error) => {
            console.log(error);
            return { path: PATH.USER_WELCOME };
          },
        );
      } else {
        storage.clearAuth();
        return { path: PATH.EXPIRED };
      }
    },
  };
};

export default Methods;
